import useLocalStorage from "@rehooks/local-storage";

import AnnouncementTile, { AnnouncementTileBackgroundType } from "components/AnnouncementTile";
import Box from "ds/components/Box";
import TileContent from "ds/components/Tile/Content";
import Typography from "ds/components/Typography";
import LinkButton from "ds/components/Button/LinkButton";

import { IAC_CONF_ANNOUNCEMENT_ID, IAC_CONF_ANNOUNCEMENT_PRIMARY_LINK } from "./constants";
import styles from "./styles.module.css";
const DashboardOverviewColumnIacConfAnnouncement = () => {
  const [closedOnboardingAnnouncements, setClosedOnboardingAnnouncements] = useLocalStorage<
    string[]
  >("dashboardWidgetAnnouncementClosed");

  if (closedOnboardingAnnouncements?.includes(IAC_CONF_ANNOUNCEMENT_ID)) {
    return null;
  }

  return (
    <AnnouncementTile
      backgroundType={AnnouncementTileBackgroundType.IacConf}
      onDismiss={() =>
        setClosedOnboardingAnnouncements(
          closedOnboardingAnnouncements
            ? [...closedOnboardingAnnouncements, IAC_CONF_ANNOUNCEMENT_ID]
            : [IAC_CONF_ANNOUNCEMENT_ID]
        )
      }
    >
      <TileContent direction="column" gap="medium">
        <Typography tag="p" variant="p-t7" className={styles.content}>
          Thu, May 15, 2025 @ 11:00am EDT
        </Typography>
        <Typography tag="p" variant="p-t4" className={styles.content}>
          Join Us at IaCConf!
        </Typography>
        <Typography tag="p" variant="p-body3" className={styles.content}>
          Join us (virtually!) to explore cutting-edge trends, learn from industry experts, and get
          hands-on with the future of infrastructure!
        </Typography>
        <Box direction="row" gap="medium" fullWidth>
          <LinkButton
            className={styles.ctaButton}
            variant="contrast"
            href={IAC_CONF_ANNOUNCEMENT_PRIMARY_LINK}
            target="_blank"
            rel="noopener noreferrer"
            fullWidth
          >
            Register now
          </LinkButton>
        </Box>
      </TileContent>
    </AnnouncementTile>
  );
};

export default DashboardOverviewColumnIacConfAnnouncement;
